var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "itemDetail" }, [
    _c(
      "div",
      {
        staticClass: "page noselect",
        class: {
          withSearchbar:
            _vm.$store.getters.searchIsRenderedNow && !_vm.addDirectly,
          noPadding: !!_vm.$store.getters.showDialogContainer,
        },
        staticStyle: { "min-height": "var(--layout-height)" },
      },
      [
        _vm.$store.state.showCatSlider && !_vm.addDirectly
          ? _c(
              "v-container",
              { staticClass: "pt-0" },
              [_c("cat-slider", {})],
              1
            )
          : _vm._e(),
        _c(
          "v-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "v-layout",
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "", md8: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "mobile" },
                      [
                        _vm.allImages.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "product-image limited d-inline-block",
                                class: {
                                  pointer:
                                    _vm.imgSource.indexOf("placeholder") === -1,
                                  hasmoreimages: _vm.hasMoreImages,
                                },
                                on: {
                                  "&click": function ($event) {
                                    return _vm.clickImage.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "prelative d-inline-block" },
                                  [
                                    _c("img", {
                                      staticClass: "mainImage",
                                      class: {
                                        pointer:
                                          _vm.imgSource.indexOf(
                                            "placeholder"
                                          ) === -1,
                                      },
                                      attrs: { src: _vm.imgSource, alt: "" },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.hasKennzeichnung &&
                        (_vm.allImages.length === 0 ||
                          (_vm.imgSource.includes("placeholde") &&
                            !_vm.$store.state.showPlaceholders))
                          ? _c("div", {
                              staticClass: "spacer-15",
                              staticStyle: { height: "40px" },
                            })
                          : _vm._e(),
                        _vm.hasKennzeichnung
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "badge",
                                  staticStyle: {
                                    position: "absolute",
                                    top: "85px",
                                    left: "12px",
                                  },
                                },
                                _vm._l(_vm.badges, function (badge) {
                                  return _c("img", {
                                    staticClass: "mr-2",
                                    attrs: { src: badge.src },
                                  })
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "v-container",
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  { staticClass: "pt-5", attrs: { xs12: "" } },
                                  [
                                    _c("div", { staticClass: "d-flex" }, [
                                      _c("div", [
                                        _vm.item.neu
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "stoerer mr-2 superValign",
                                              },
                                              [_vm._v("NEU")]
                                            )
                                          : _vm._e(),
                                        _c("h2", {
                                          staticClass:
                                            "itemTitle headColor d-inline hyphens",
                                          domProps: {
                                            innerHTML: _vm._s(_vm.item.nameDE),
                                          },
                                        }),
                                        _vm.item.substances &&
                                        _vm.item.substances.lAlk
                                          ? _c("span", [
                                              _c(
                                                "sup",
                                                {
                                                  staticClass: "alk",
                                                  class: {
                                                    bgLight: _vm.bgLight,
                                                  },
                                                },
                                                [_vm._v("mit Alkohol")]
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _vm.$store.state.enableFavs
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "heart d-inline-block mr-2",
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "rounded100",
                                                  staticStyle: {
                                                    width: "35px",
                                                    height: "35px",
                                                  },
                                                  attrs: { dark: "", icon: "" },
                                                  nativeOn: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      return _vm.switchFavorite.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.isFavorite
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            medium: "",
                                                            color: "red",
                                                          },
                                                        },
                                                        [_vm._v("mdi-heart")]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            medium: "",
                                                            color: "#888888",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-heart-outline"
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "v-flex",
                                  {
                                    staticStyle: { "padding-top": "0" },
                                    attrs: { xs12: "" },
                                  },
                                  [
                                    _vm.item.descriptionDE
                                      ? _c("div", {
                                          staticClass: "pt-3 pb-3",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.item.descriptionDE
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.$store.state.enableBestand &&
                                    _vm.$store.state
                                      .enableBestandanzeigeInItemList &&
                                    _vm.item.bestand &&
                                    _vm.item.bestand !== -1
                                      ? _c("div", [
                                          _vm._v(
                                            " Bestand: " +
                                              _vm._s(_vm.item.bestand) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.item.gramm
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { staticClass: "mr-1" },
                                              [_vm._v("mdi-weight-gram")]
                                            ),
                                            _vm._v(
                                              " Gewicht: " +
                                                _vm._s(_vm.item.gramm) +
                                                "g "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c("div", { staticClass: "d-flex mt-3" }, [
                                      _vm.item.sizes &&
                                      _vm.item.sizes.length === 1 &&
                                      _vm.item.sizes[0].vol
                                        ? _c(
                                            "div",
                                            { staticClass: "flex-shrink-0" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.item.sizes[0].vol)
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "headline",
                                                  staticStyle: { opacity: "0" },
                                                },
                                                [_vm._v("1")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-shrink-0 text-no-wrap fastGrow text-left",
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _vm.total
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      !_vm.$store.getters
                                                        .hidePrices
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "biggerFont",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Preis: "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "preis titleFont ml-2",
                                                                  class: {
                                                                    oprice:
                                                                      _vm.item
                                                                        .streichPreis,
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "priceTotal"
                                                                      )(
                                                                        _vm.total
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm.readyToAdd(
                                                                _vm.item
                                                              ) &&
                                                              _vm.item
                                                                .streichPreis
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "streichPreisCrossed ml-2",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "price"
                                                                          )(
                                                                            _vm
                                                                              .item
                                                                              .streichPreis
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.item.kilopreis &&
                                                      !_vm.$store.getters
                                                        .hidePrices
                                                        ? _c("div", [
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.item
                                                                    .kilopreis
                                                                )
                                                              ),
                                                            ]),
                                                          ])
                                                        : _vm._e(),
                                                      !_vm.$store.getters
                                                        .hidePrices
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mb-4",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "inkl. MwSt. "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm.item.days &&
                                                      _vm.$store.state
                                                        .showItemDaysAvailability
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pt-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Verfügbarkeit: " +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "displayDays"
                                                                    )(
                                                                      _vm.item
                                                                        .days
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      !_vm.buyable
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "notAvailable pt-2 pb-2",
                                                            },
                                                            [
                                                              _vm.item
                                                                .redAvailabilityInfo
                                                                ? [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .item
                                                                            .redAvailabilityInfo
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                : [
                                                                    !_vm.item
                                                                      .buyable
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Der Artikel ist nicht online bestellbar"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm
                                                                          .$store
                                                                          .getters
                                                                          .inhouse &&
                                                                        !_vm
                                                                          .item
                                                                          .buyableForInhouse
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Der Artikel ist Inhouse nicht bestellbar"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : !_vm
                                                                          .$store
                                                                          .getters
                                                                          .inhouse &&
                                                                        !!_vm
                                                                          .item
                                                                          .buyableForInhouse
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Der Artikel ist nur Inhouse bestellbar"
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Der Artikel ist nicht online bestellbar"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                  ],
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("div", { staticClass: "spacer-15" }),
                                    _c("MyLine"),
                                    _c("div", { staticClass: "spacer-15" }),
                                    _vm.item.sizes && _vm.item.sizes.length > 1
                                      ? _c("div", [
                                          _c("h4", [
                                            _vm._v("Wähle deine Größe"),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "n-marge" },
                                            _vm._l(
                                              _vm.item.sizes,
                                              function (size) {
                                                return _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      "active-class": "primary",
                                                      "input-value":
                                                        _vm.currentVol ===
                                                        size.vol,
                                                    },
                                                    nativeOn: {
                                                      "&click": function (
                                                        $event
                                                      ) {
                                                        return _vm.switchSize(
                                                          size.vol
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-avatar",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.currentVol ===
                                                              size.vol,
                                                            expression:
                                                              "currentVol === size.vol",
                                                          },
                                                        ],
                                                        attrs: { left: "" },
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("mdi-check"),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("sizeDisplay")(
                                                            size
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    !_vm.$store.getters
                                                      .hidePrices
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "priceTotal"
                                                              )(size.price)
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.hasExtras && _vm.loaded
                                      ? _c(
                                          "div",
                                          { staticClass: "pt-3 fade-in" },
                                          [
                                            _c(
                                              "h4",
                                              { attrs: { id: "extras" } },
                                              [_vm._v("Deine Extras:")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "n-marge" },
                                              _vm._l(
                                                _vm.item.extras.styles,
                                                function (extra) {
                                                  return _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "ma-1",
                                                      attrs: {
                                                        "input-value":
                                                          extra.aaaSelected,
                                                        "active-class":
                                                          "primary",
                                                      },
                                                      nativeOn: {
                                                        "&click": function (
                                                          $event
                                                        ) {
                                                          return _vm.switchExtra(
                                                            extra
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-avatar",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                extra.aaaSelected,
                                                              expression:
                                                                "extra.aaaSelected",
                                                            },
                                                          ],
                                                          attrs: { left: "" },
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("mdi-check"),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            extra.labelDE
                                                          ),
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.getExtraCost(extra) >
                                                      0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ml-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "displayExtraPrice"
                                                                    )(
                                                                      extra,
                                                                      _vm.currentVol
                                                                    )
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.hasVariants && _vm.loaded
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pt-3 fade-in",
                                            attrs: { id: "variants" },
                                          },
                                          [
                                            _vm._l(
                                              _vm.item.extras.variants,
                                              function (variant, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: variant.show,
                                                        expression:
                                                          "variant.show",
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: variant.aaaIndex,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "variants",
                                                      },
                                                      [
                                                        index > 0
                                                          ? _c("div", {
                                                              staticClass:
                                                                "spacer-15",
                                                            })
                                                          : _vm._e(),
                                                        variant.dropdown
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-center bigger-input",
                                                              },
                                                              [
                                                                !variant.ext
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "min-width":
                                                                              "30vw",
                                                                            "max-width":
                                                                              "50vw",
                                                                          },
                                                                      },
                                                                      [
                                                                        variant.title &&
                                                                        variant.title.indexOf(
                                                                          "<"
                                                                        ) !== -1
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        variant.title
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "h4",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    variant.title
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                dark: !_vm.bgLight,
                                                                              },
                                                                            nativeOn:
                                                                              {
                                                                                "&click":
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.removeExtraPortion(
                                                                                      index,
                                                                                      variant.aaaIndex
                                                                                    )
                                                                                  },
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-close-thick "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                _c("div", [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "prelative",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-select",
                                                                        {
                                                                          staticClass:
                                                                            "ml-4 dropdownSelect",
                                                                          staticStyle:
                                                                            {
                                                                              "padding-top":
                                                                                "0",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              dark: !_vm.bgLight,
                                                                              outlined:
                                                                                "",
                                                                              items:
                                                                                variant.options,
                                                                              "item-text":
                                                                                "aaaDisplayLabel",
                                                                              "item-value":
                                                                                "id",
                                                                              "return-object":
                                                                                "",
                                                                              "single-line":
                                                                                "",
                                                                              "hide-details":
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              _vm.selectDropdOption,
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.changeVariant(
                                                                                  variant,
                                                                                  index
                                                                                )
                                                                              },
                                                                          },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function (
                                                                                    data
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          domProps:
                                                                                            {
                                                                                              innerHTML:
                                                                                                _vm._s(
                                                                                                  data
                                                                                                    .item
                                                                                                    .aaaDisplayLabel
                                                                                                ),
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                                {
                                                                                  key: "selection",
                                                                                  fn: function (
                                                                                    data
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-no-wrap",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "b",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "displayOptionWithoutSplits"
                                                                                                  )(
                                                                                                    data.item
                                                                                                  )
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          data
                                                                                            .item
                                                                                            .cost
                                                                                            ? _c(
                                                                                                "span",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "(" +
                                                                                                      _vm._s(
                                                                                                        _vm._f(
                                                                                                          "displayOptionPrice"
                                                                                                        )(
                                                                                                          data
                                                                                                            .item
                                                                                                            .cost,
                                                                                                          !!variant.replaceArticle
                                                                                                        )
                                                                                                      ) +
                                                                                                      ")"
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectModels[
                                                                                  "sm" +
                                                                                    index
                                                                                ],
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectModels,
                                                                                    "sm" +
                                                                                      index,
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "selectModels['sm'+index]",
                                                                            },
                                                                        }
                                                                      ),
                                                                      !_vm
                                                                        .selectModels[
                                                                        "sm" +
                                                                          index
                                                                      ] ||
                                                                      _vm
                                                                        .selectModels[
                                                                        "sm" +
                                                                          index
                                                                      ].id ===
                                                                        ""
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "absSelects",
                                                                              class:
                                                                                {
                                                                                  bgLight:
                                                                                    _vm.bgLight,
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "superCenter",
                                                                                },
                                                                                [
                                                                                  variant.optional
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "optional wählbar"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "bitte wählen"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              [
                                                                variant.title &&
                                                                variant.title.indexOf(
                                                                  "<"
                                                                ) !== -1
                                                                  ? _c("div", {
                                                                      domProps:
                                                                        {
                                                                          innerHTML:
                                                                            _vm._s(
                                                                              variant.title
                                                                            ),
                                                                        },
                                                                    })
                                                                  : _c("h4", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          variant.title
                                                                        )
                                                                      ),
                                                                    ]),
                                                                _vm._l(
                                                                  variant.options,
                                                                  function (
                                                                    option
                                                                  ) {
                                                                    return _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option pointer",
                                                                        class: {
                                                                          selected:
                                                                            option.aaaSelected,
                                                                        },
                                                                        on: {
                                                                          "&click":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.selectOption(
                                                                                variant,
                                                                                option
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex",
                                                                          },
                                                                          [
                                                                            variant.multi
                                                                              ? _c(
                                                                                  "div",
                                                                                  [
                                                                                    option.aaaSelected
                                                                                      ? _c(
                                                                                          "v-icon",
                                                                                          [
                                                                                            _vm._v(
                                                                                              " mdi-check-box-outline "
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _c(
                                                                                          "v-icon",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "mdi-checkbox-blank-outline"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _c(
                                                                                  "div",
                                                                                  [
                                                                                    option.aaaSelected
                                                                                      ? _c(
                                                                                          "v-icon",
                                                                                          {
                                                                                            class:
                                                                                              {
                                                                                                invertIcon:
                                                                                                  !_vm.bgLight,
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " mdi-check-circle-outline "
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _c(
                                                                                          "v-icon",
                                                                                          [
                                                                                            _vm._v(
                                                                                              'mdi-checkbox-blank-circle-outline :class="{invertIcon:!bgLight}"> '
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "fasterGrow",
                                                                                staticStyle:
                                                                                  {
                                                                                    "padding-left":
                                                                                      "3%",
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        option.labelDE
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "v-spacer"
                                                                            ),
                                                                            !_vm
                                                                              .item
                                                                              .extras
                                                                              .combinations
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        float:
                                                                                          "right",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          _vm._f(
                                                                                            "displayOptionPrice"
                                                                                          )(
                                                                                            option.cost,
                                                                                            !!variant.replaceArticle
                                                                                          )
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                            !_vm
                                                                              .$store
                                                                              .getters
                                                                              .hidePrices &&
                                                                            _vm
                                                                              .item
                                                                              .extras
                                                                              .combinations &&
                                                                            _vm
                                                                              .item
                                                                              .extras
                                                                              .variants
                                                                              .length ===
                                                                              1
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        float:
                                                                                          "right",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        class:
                                                                                          {
                                                                                            oprice:
                                                                                              _vm.item.extras.combinations.find(
                                                                                                (
                                                                                                  c
                                                                                                ) =>
                                                                                                  c.id ===
                                                                                                  option.id
                                                                                              )
                                                                                                .streichPreis,
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm._f(
                                                                                              "price"
                                                                                            )(
                                                                                              _vm.item.extras.combinations.find(
                                                                                                (
                                                                                                  c
                                                                                                ) =>
                                                                                                  c.id ===
                                                                                                  option.id
                                                                                              )
                                                                                                .price
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _vm.item.extras.combinations.find(
                                                                                      (
                                                                                        c
                                                                                      ) =>
                                                                                        c.id ===
                                                                                        option.id
                                                                                    )
                                                                                      .streichPreis
                                                                                      ? _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "streichPreisCrossed ml-2",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                _vm._f(
                                                                                                  "price"
                                                                                                )(
                                                                                                  _vm.item.extras.combinations.find(
                                                                                                    (
                                                                                                      c
                                                                                                    ) =>
                                                                                                      c.id ===
                                                                                                      option.id
                                                                                                  )
                                                                                                    .streichPreis
                                                                                                )
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                variant.optional &&
                                                                !variant.implicit
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "option pointer d-flex",
                                                                        class: {
                                                                          selected:
                                                                            variant.aaaOhne,
                                                                        },
                                                                        on: {
                                                                          "&click":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.selectOhne(
                                                                                variant
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        variant.aaaOhne
                                                                          ? _c(
                                                                              "v-icon",
                                                                              {
                                                                                class:
                                                                                  {
                                                                                    invertIcon:
                                                                                      !_vm.bgLight,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-check-circle-outline"
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "v-icon",
                                                                              {
                                                                                class:
                                                                                  {
                                                                                    invertIcon:
                                                                                      !_vm.bgLight,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-checkbox-blank-circle-outline"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                "padding-left":
                                                                                  "3%",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "ohne"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              2
                                                            ),
                                                        variant.extendable &&
                                                        variant.showExtraPortion
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mt-3 mb-1 headColor",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "1.2em",
                                                                },
                                                                on: {
                                                                  "&click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.addExtraPortion(
                                                                        variant.aaaIndex,
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticClass:
                                                                      "btn-mini",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "+ Extra Portion"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c("div", {
                                              staticClass: "spacer-20",
                                            }),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm.loaded
                                  ? _c(
                                      "v-flex",
                                      {
                                        staticClass: "fade-in",
                                        attrs: { xs12: "" },
                                      },
                                      [
                                        _vm.buyable
                                          ? _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-shrink-0 align-self-center",
                                                  },
                                                  [
                                                    !_vm.item.unikat
                                                      ? _c("table", [
                                                          _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "counterStuff minus",
                                                                on: {
                                                                  "&click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clickMinus.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  class: {
                                                                    invertImg:
                                                                      !_vm.bgLight,
                                                                  },
                                                                  attrs: {
                                                                    src: require("../assets/icons/item-minus.png"),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "counter",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.multiplicator
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "counterStuff",
                                                                on: {
                                                                  "&click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clickPlus.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  class: {
                                                                    invertImg:
                                                                      !_vm.bgLight,
                                                                  },
                                                                  attrs: {
                                                                    src: require("../assets/icons/item-plus.png"),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm.item.sizes &&
                                                _vm.item.sizes.length > 0
                                                  ? _c("add-to-cart-button", {
                                                      staticClass: "ml-3",
                                                      attrs: {
                                                        noblink: _vm.noblink,
                                                        small: true,
                                                        total: 0,
                                                      },
                                                      nativeOn: {
                                                        "&click": function (
                                                          $event
                                                        ) {
                                                          return _vm.addToCart.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.$store.state.enableItemNote &&
                                        _vm.buyable &&
                                        _vm.loaded
                                          ? _c(
                                              "div",
                                              { staticClass: "pt-4 itmExtras" },
                                              [
                                                _c("v-text-field", {
                                                  staticClass:
                                                    "nolabel panelField",
                                                  attrs: {
                                                    placeholder: "Anmerkung",
                                                    illed: "",
                                                    "hide-details": "",
                                                    outlined: "",
                                                    clearable: "",
                                                    required: "",
                                                  },
                                                  model: {
                                                    value: _vm.item.notes,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.item,
                                                        "notes",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.notes",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-flex",
                                  { attrs: { x12: "" } },
                                  [
                                    !_vm.item.ticket
                                      ? _c(
                                          "v-expansion-panels",
                                          {
                                            staticClass: "pt-5 panels",
                                            staticStyle: {
                                              "overflow-x": "hidden",
                                            },
                                          },
                                          [
                                            _vm.item.inhaltsstoffe
                                              ? _c(
                                                  "v-expansion-panel",
                                                  { key: "1" },
                                                  [
                                                    _c(
                                                      "v-expansion-panel-header",
                                                      [_vm._v("Inhaltsstoffe")]
                                                    ),
                                                    _c(
                                                      "v-expansion-panel-content",
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.item
                                                                .inhaltsstoffe
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.item.nutritions
                                              ? _c(
                                                  "v-expansion-panel",
                                                  { key: "2" },
                                                  [
                                                    _c(
                                                      "v-expansion-panel-header",
                                                      [_vm._v("Nährwerte")]
                                                    ),
                                                    _c(
                                                      "v-expansion-panel-content",
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.item
                                                                .nutritions
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "v-expansion-panel",
                                              { key: "3" },
                                              [
                                                _c("v-expansion-panel-header", [
                                                  _vm._v(
                                                    "Allergene & Zusatzstoffe "
                                                  ),
                                                ]),
                                                _vm.combinedAllergene
                                                  ? _c(
                                                      "v-expansion-panel-content",
                                                      [
                                                        _c("div", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.combinedAllergene
                                                            ),
                                                          },
                                                        }),
                                                        _vm.combinedAllergene &&
                                                        _vm.combinedAllergene.indexOf(
                                                          "<sup>"
                                                        ) !== -1
                                                          ? _c(
                                                              "AllergenLegende"
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-expansion-panel-content",
                                                      [
                                                        _vm._v(
                                                          "Dieser Artikel enthält keine Angaben zu Allergenen und Zusatzstoffen "
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c("div", { staticClass: "pt-5" }, [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "text-none btn-df accentBtn",
                                              nativeOn: {
                                                "&click": function ($event) {
                                                  return _vm.clickWeiter.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v("Weiter Einkaufen"),
                                              ]),
                                            ]
                                          ),
                                          _vm.showWeiter
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "ml-3 btn-df checkoutButtonAnimation text-none",
                                                  nativeOn: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      return _vm.goCart.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(" CHECKOUT "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        medium: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " mdi-chevron-right "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("div", { staticClass: "spacer-20" }),
                                    _vm.itemClone
                                      ? _c(
                                          "div",
                                          [
                                            _c("ItemDetailsTabs", {
                                              attrs: { item: _vm.itemClone },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "spacer-25" }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "tablet" },
                      [
                        _c("div", { staticClass: "spacer-25" }),
                        _c(
                          "v-container",
                          { attrs: { "grid-list-xl": "" } },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-flex",
                                  {
                                    staticClass:
                                      "text-center text-sm-right text-md-center prelative",
                                    attrs: { xs6: "" },
                                  },
                                  [
                                    _vm.allImages.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "product-image limited d-inline-block",
                                            class: {
                                              pointer:
                                                _vm.imgSource.indexOf(
                                                  "placeholder"
                                                ) === -1,
                                              hasmoreimages: _vm.hasMoreImages,
                                            },
                                            on: {
                                              "&click": function ($event) {
                                                return _vm.clickImage.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "prelative d-inline-block",
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "mainImage",
                                                  class: {
                                                    pointer:
                                                      _vm.imgSource.indexOf(
                                                        "placeholder"
                                                      ) === -1,
                                                  },
                                                  attrs: {
                                                    src: _vm.imgSource,
                                                    alt: "",
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm.hasMoreImages
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "moreImagesLeft",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "moreImage",
                                                      style: {
                                                        "background-image":
                                                          "url(" +
                                                          _vm.item.image +
                                                          ")",
                                                      },
                                                      on: {
                                                        "&click": function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          _vm.currentSource = ""
                                                          _vm.showLightbox = true
                                                        },
                                                        mouseover: function (
                                                          $event
                                                        ) {
                                                          _vm.currentSource = ""
                                                        },
                                                      },
                                                    }),
                                                    _vm._l(
                                                      _vm.item.moreImages,
                                                      function (img) {
                                                        return _c("div", {
                                                          staticClass:
                                                            "moreImage",
                                                          style: {
                                                            "background-image":
                                                              "url(" +
                                                              img +
                                                              ")",
                                                          },
                                                          on: {
                                                            "&click": function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              _vm.currentSource =
                                                                img
                                                              _vm.showLightbox = true
                                                            },
                                                            mouseover:
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.currentSource =
                                                                  img
                                                              },
                                                          },
                                                        })
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.hasKennzeichnung
                                      ? _c(
                                          "div",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "badge",
                                                staticStyle: {
                                                  position: "absolute",
                                                  top: "11px",
                                                  right: "5px",
                                                },
                                              },
                                              _vm._l(
                                                _vm.badges,
                                                function (badge) {
                                                  return _c("img", {
                                                    staticClass: "mr-2",
                                                    attrs: { src: badge.src },
                                                  })
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("div", {
                                      staticClass: "spacer-15",
                                      attrs: { id: "accordion" },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "limited d-inline-block text-left",
                                      },
                                      [
                                        !_vm.item.ticket
                                          ? _c(
                                              "v-expansion-panels",
                                              {
                                                staticClass: "panels",
                                                staticStyle: {
                                                  "overflow-x": "hidden",
                                                },
                                              },
                                              [
                                                _vm.item.inhaltsstoffe
                                                  ? _c(
                                                      "v-expansion-panel",
                                                      { key: "1" },
                                                      [
                                                        _c(
                                                          "v-expansion-panel-header",
                                                          [
                                                            _vm._v(
                                                              "Inhaltsstoffe"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-expansion-panel-content",
                                                          [
                                                            _c("div", {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.item
                                                                      .inhaltsstoffe
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.item.nutritions
                                                  ? _c(
                                                      "v-expansion-panel",
                                                      { key: "2" },
                                                      [
                                                        _c(
                                                          "v-expansion-panel-header",
                                                          [_vm._v("Nährwerte")]
                                                        ),
                                                        _c(
                                                          "v-expansion-panel-content",
                                                          [
                                                            _c("div", {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.item
                                                                      .nutritions
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-expansion-panel",
                                                  {
                                                    key: "3",
                                                    on: {
                                                      click: _vm.clickAccordion,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-expansion-panel-header",
                                                      [
                                                        _vm._v(
                                                          "Allergene & Zusatzstoffe "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm.combinedAllergene
                                                      ? _c(
                                                          "v-expansion-panel-content",
                                                          [
                                                            _c("div", {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.combinedAllergene
                                                                  ),
                                                              },
                                                            }),
                                                            _vm.combinedAllergene &&
                                                            _vm.combinedAllergene.indexOf(
                                                              "<sup>"
                                                            ) !== -1
                                                              ? _c(
                                                                  "AllergenLegende"
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _c(
                                                          "v-expansion-panel-content",
                                                          [
                                                            _vm._v(
                                                              "Dieser Artikel enthält keine Angaben zu Allergenen und Zusatzstoffen "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                                _vm._l(
                                                  _vm.item.merkmalgruppen,
                                                  function (mg, index) {
                                                    return _vm.item
                                                      .merkmalgruppen
                                                      ? _c(
                                                          "v-expansion-panel",
                                                          { key: index + 4 },
                                                          [
                                                            _c(
                                                              "v-expansion-panel-header",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    mg.name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-expansion-panel-content",
                                                              [
                                                                _vm.hasOnlyKeys(
                                                                  mg.keyValues
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      _vm._l(
                                                                        mg.keyValues,
                                                                        function (
                                                                          kv
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  kv.key
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      0
                                                                    )
                                                                  : _vm._l(
                                                                      mg.keyValues,
                                                                      function (
                                                                        kv
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    flex: "1 1 50%",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    class:
                                                                                      {
                                                                                        "pl-3":
                                                                                          kv.params &&
                                                                                          kv
                                                                                            .params
                                                                                            .indent,
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        kv.key
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    flex: "1 1 50%",
                                                                                  },
                                                                                domProps:
                                                                                  {
                                                                                    innerHTML:
                                                                                      _vm._s(
                                                                                        kv.value
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                              ],
                                                              2
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs6: "" } },
                                  [
                                    _c("div", { staticClass: "d-flex" }, [
                                      _c("div", [
                                        _vm.item.neu
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "stoerer mr-2 superValign",
                                              },
                                              [_vm._v("NEU")]
                                            )
                                          : _vm._e(),
                                        _c("h1", {
                                          staticClass:
                                            "itemTitle d-inline withSup hyphens",
                                          staticStyle: { "font-size": "2em" },
                                          domProps: {
                                            innerHTML: _vm._s(_vm.item.nameDE),
                                          },
                                        }),
                                        _vm.item.substances &&
                                        _vm.item.substances.lAlk
                                          ? _c("span", [
                                              _c(
                                                "sup",
                                                {
                                                  staticClass: "alk supHigher",
                                                  class: {
                                                    bgLight: _vm.bgLight,
                                                  },
                                                },
                                                [_vm._v("mit Alkohol")]
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                      _vm.$store.state.enableFavs
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "heart d-inline-block mr-2",
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "rounded100",
                                                  staticStyle: {
                                                    width: "35px",
                                                    height: "35px",
                                                  },
                                                  attrs: { dark: "", icon: "" },
                                                  nativeOn: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      return _vm.switchFavorite.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm.isFavorite
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            medium: "",
                                                            color: "red",
                                                          },
                                                        },
                                                        [_vm._v("mdi-heart")]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            medium: "",
                                                            color: "#888888",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-heart-outline"
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm.item.descriptionDE
                                      ? _c("p", {
                                          staticClass: "pt-3",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.item.descriptionDE
                                            ),
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.$store.state.enableBestand &&
                                    _vm.$store.state
                                      .enableBestandanzeigeInItemList &&
                                    _vm.item.bestand &&
                                    _vm.item.bestand !== -1
                                      ? _c("div", [
                                          _vm._v(
                                            " Bestand: " +
                                              _vm._s(_vm.item.bestand) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.item.gramm ||
                                    (_vm.item.sizes &&
                                      _vm.item.sizes.length === 1 &&
                                      _vm.item.sizes[0].vol)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.item.sizes[0].vol)
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.item.cmRatio
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _c("v-icon", [_vm._v("mdi-corn")]),
                                            _vm._v(
                                              " Getreidemischverhältnis: " +
                                                _vm._s(_vm.item.cmRatio) +
                                                " "
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.item.days &&
                                    _vm.$store.state.showItemDaysAvailability
                                      ? _c("div", { staticClass: "pt-2" }, [
                                          _vm._v(
                                            " Verfügbarkeit: " +
                                              _vm._s(
                                                _vm._f("displayDays")(
                                                  _vm.item.days
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    !_vm.buyable
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "notAvailable pt-2 pb-2",
                                          },
                                          [
                                            _vm.item.redAvailabilityInfo
                                              ? [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.item
                                                          .redAvailabilityInfo
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              : [
                                                  !_vm.item.buyable
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "Der Artikel ist nicht online bestellbar"
                                                        ),
                                                      ])
                                                    : _vm.$store.getters
                                                        .inhouse &&
                                                      !_vm.item
                                                        .buyableForInhouse
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "Der Artikel ist Inhouse nicht bestellbar"
                                                        ),
                                                      ])
                                                    : !_vm.$store.getters
                                                        .inhouse &&
                                                      !!_vm.item
                                                        .buyableForInhouse
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "Der Artikel ist nur Inhouse bestellbar"
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          "Der Artikel ist nicht online bestellbar"
                                                        ),
                                                      ]),
                                                ],
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _c("div", { staticClass: "spacer-15" }),
                                    _c("MyLine"),
                                    _c("div", { staticClass: "spacer-15" }),
                                    _vm.item.sizes && _vm.item.sizes.length > 1
                                      ? _c("div", [
                                          _c("h4", [
                                            _vm._v("Wähle deine Größe"),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "n-marge" },
                                            _vm._l(
                                              _vm.item.sizes,
                                              function (size) {
                                                return _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      "active-class": "primary",
                                                      "input-value":
                                                        _vm.currentVol ===
                                                        size.vol,
                                                    },
                                                    nativeOn: {
                                                      "&click": function (
                                                        $event
                                                      ) {
                                                        return _vm.switchSize(
                                                          size.vol
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-avatar",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              _vm.currentVol ===
                                                              size.vol,
                                                            expression:
                                                              "currentVol === size.vol",
                                                          },
                                                        ],
                                                        attrs: { left: "" },
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("mdi-check"),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("sizeDisplay")(
                                                            size
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    !_vm.$store.getters
                                                      .hidePrices
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "priceTotal"
                                                              )(size.price)
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm.hasVariants && _vm.loaded
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pt-3 fade-in",
                                            attrs: { id: "variants" },
                                          },
                                          _vm._l(
                                            _vm.item.extras.variants,
                                            function (variant, index) {
                                              return _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: variant.show,
                                                      expression:
                                                        "variant.show",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: variant.aaaIndex,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "variants" },
                                                    [
                                                      index > 0
                                                        ? _c("div", {
                                                            staticClass:
                                                              "spacer-15",
                                                          })
                                                        : _vm._e(),
                                                      variant.dropdown
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-center bigger-input",
                                                            },
                                                            [
                                                              !variant.ext
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          flex: "0 0 40%",
                                                                        },
                                                                    },
                                                                    [
                                                                      variant.title &&
                                                                      variant.title.indexOf(
                                                                        "<"
                                                                      ) !== -1
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              domProps:
                                                                                {
                                                                                  innerHTML:
                                                                                    _vm._s(
                                                                                      variant.title
                                                                                    ),
                                                                                },
                                                                            }
                                                                          )
                                                                        : _c(
                                                                            "h4",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  variant.title
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              dark: !_vm.bgLight,
                                                                            },
                                                                          nativeOn:
                                                                            {
                                                                              "&click":
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.removeExtraPortion(
                                                                                    index,
                                                                                    variant.aaaIndex
                                                                                  )
                                                                                },
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-close-thick "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    flex: "0 0 60%",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "prelative",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-select",
                                                                        {
                                                                          staticClass:
                                                                            "ml-4 dropdownSelect",
                                                                          staticStyle:
                                                                            {
                                                                              "padding-top":
                                                                                "0",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              dark: !_vm.bgLight,
                                                                              outlined:
                                                                                "",
                                                                              items:
                                                                                variant.options,
                                                                              "item-text":
                                                                                "aaaDisplayLabel",
                                                                              "item-value":
                                                                                "id",
                                                                              "return-object":
                                                                                "",
                                                                              "single-line":
                                                                                "",
                                                                              "hide-details":
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            input:
                                                                              _vm.selectDropdOption,
                                                                            change:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.changeVariant(
                                                                                  variant,
                                                                                  index
                                                                                )
                                                                              },
                                                                          },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "item",
                                                                                  fn: function (
                                                                                    data
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          domProps:
                                                                                            {
                                                                                              innerHTML:
                                                                                                _vm._s(
                                                                                                  data
                                                                                                    .item
                                                                                                    .aaaDisplayLabel
                                                                                                ),
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                                {
                                                                                  key: "selection",
                                                                                  fn: function (
                                                                                    data
                                                                                  ) {
                                                                                    return [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-no-wrap",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "b",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "displayOptionWithoutSplits"
                                                                                                  )(
                                                                                                    data.item
                                                                                                  )
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          ),
                                                                                          data
                                                                                            .item
                                                                                            .cost
                                                                                            ? _c(
                                                                                                "span",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "(" +
                                                                                                      _vm._s(
                                                                                                        _vm._f(
                                                                                                          "displayOptionPrice"
                                                                                                        )(
                                                                                                          data
                                                                                                            .item
                                                                                                            .cost,
                                                                                                          !!variant.replaceArticle
                                                                                                        )
                                                                                                      ) +
                                                                                                      ")"
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .selectModels[
                                                                                  "sm" +
                                                                                    index
                                                                                ],
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.selectModels,
                                                                                    "sm" +
                                                                                      index,
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "selectModels['sm'+index]",
                                                                            },
                                                                        }
                                                                      ),
                                                                      !_vm
                                                                        .selectModels[
                                                                        "sm" +
                                                                          index
                                                                      ] ||
                                                                      _vm
                                                                        .selectModels[
                                                                        "sm" +
                                                                          index
                                                                      ].id ===
                                                                        ""
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "absSelects",
                                                                              class:
                                                                                {
                                                                                  bgLight:
                                                                                    _vm.bgLight,
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "superCenter",
                                                                                },
                                                                                [
                                                                                  variant.optional
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "optional wählbar"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "bitte wählen"
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            [
                                                              variant.title &&
                                                              variant.title.indexOf(
                                                                "<"
                                                              ) !== -1
                                                                ? _c("h4", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          variant.title
                                                                        ),
                                                                    },
                                                                  })
                                                                : _c("h4", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        variant.title
                                                                      )
                                                                    ),
                                                                  ]),
                                                              _vm._l(
                                                                variant.options,
                                                                function (
                                                                  option
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "option pointer d-flex",
                                                                      class: {
                                                                        selected:
                                                                          option.aaaSelected,
                                                                      },
                                                                      on: {
                                                                        "&click":
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.selectOption(
                                                                              variant,
                                                                              option
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      variant.multi
                                                                        ? _c(
                                                                            "span",
                                                                            [
                                                                              option.aaaSelected
                                                                                ? _c(
                                                                                    "v-icon",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-check-box-outline"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "v-icon",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-checkbox-blank-outline"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ],
                                                                            1
                                                                          )
                                                                        : _c(
                                                                            "span",
                                                                            [
                                                                              option.aaaSelected
                                                                                ? _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      class:
                                                                                        {
                                                                                          invertIcon:
                                                                                            !_vm.bgLight,
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-check-circle-outline"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      class:
                                                                                        {
                                                                                          invertIcon:
                                                                                            !_vm.bgLight,
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-checkbox-blank-circle-outline"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "fasterGrow",
                                                                          staticStyle:
                                                                            {
                                                                              "padding-left":
                                                                                "3%",
                                                                            },
                                                                          domProps:
                                                                            {
                                                                              innerHTML:
                                                                                _vm._s(
                                                                                  option.labelDE
                                                                                ),
                                                                            },
                                                                        }
                                                                      ),
                                                                      !_vm.item
                                                                        .extras
                                                                        .combinations
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  float:
                                                                                    "right",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    _vm._f(
                                                                                      "displayOptionPrice"
                                                                                    )(
                                                                                      option.cost,
                                                                                      !!variant.replaceArticle
                                                                                    )
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      !_vm
                                                                        .$store
                                                                        .getters
                                                                        .hidePrices &&
                                                                      _vm.item
                                                                        .extras
                                                                        .combinations &&
                                                                      _vm.item
                                                                        .extras
                                                                        .variants
                                                                        .length ===
                                                                        1
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  float:
                                                                                    "right",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  class:
                                                                                    {
                                                                                      oprice:
                                                                                        _vm.item.extras.combinations.find(
                                                                                          (
                                                                                            c
                                                                                          ) =>
                                                                                            c.id ===
                                                                                            option.id
                                                                                        )
                                                                                          .streichPreis,
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm._f(
                                                                                        "price"
                                                                                      )(
                                                                                        _vm.item.extras.combinations.find(
                                                                                          (
                                                                                            c
                                                                                          ) =>
                                                                                            c.id ===
                                                                                            option.id
                                                                                        )
                                                                                          .price
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm.item.extras.combinations.find(
                                                                                (
                                                                                  c
                                                                                ) =>
                                                                                  c.id ===
                                                                                  option.id
                                                                              )
                                                                                .streichPreis
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "streichPreisCrossed ml-2",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm._f(
                                                                                            "price"
                                                                                          )(
                                                                                            _vm.item.extras.combinations.find(
                                                                                              (
                                                                                                c
                                                                                              ) =>
                                                                                                c.id ===
                                                                                                option.id
                                                                                            )
                                                                                              .streichPreis
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              variant.optional &&
                                                              !variant.implicit
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "option pointer d-flex",
                                                                      class: {
                                                                        selected:
                                                                          variant.aaaOhne,
                                                                      },
                                                                      on: {
                                                                        "&click":
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.selectOhne(
                                                                              variant
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      variant.aaaOhne
                                                                        ? _c(
                                                                            "v-icon",
                                                                            {
                                                                              class:
                                                                                {
                                                                                  invertIcon:
                                                                                    !_vm.bgLight,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-check-circle-outline"
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "v-icon",
                                                                            {
                                                                              class:
                                                                                {
                                                                                  invertIcon:
                                                                                    !_vm.bgLight,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-checkbox-blank-circle-outline"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "padding-left":
                                                                                "3%",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "ohne"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                      variant.extendable &&
                                                      variant.showExtraPortion
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-3 mb-1 headColor",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "1.2em",
                                                              },
                                                              on: {
                                                                "&click":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.addExtraPortion(
                                                                      variant.aaaIndex,
                                                                      index
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "btn-mini",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "+ Extra Portion"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                    _vm.hasExtras && _vm.loaded
                                      ? _c(
                                          "div",
                                          { staticClass: "pt-3 fade-in" },
                                          [
                                            _c(
                                              "h4",
                                              { attrs: { id: "extras" } },
                                              [_vm._v("Deine Extras:")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "n-marge" },
                                              _vm._l(
                                                _vm.item.extras.styles,
                                                function (extra) {
                                                  return _c(
                                                    "v-chip",
                                                    {
                                                      staticClass: "ma-1",
                                                      attrs: {
                                                        "input-value":
                                                          extra.aaaSelected,
                                                        "active-class":
                                                          "primary",
                                                      },
                                                      nativeOn: {
                                                        "&click": function (
                                                          $event
                                                        ) {
                                                          return _vm.switchExtra(
                                                            extra
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-avatar",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                extra.aaaSelected,
                                                              expression:
                                                                "extra.aaaSelected",
                                                            },
                                                          ],
                                                          attrs: { left: "" },
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("mdi-check"),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            extra.labelDE
                                                          ),
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _vm.getExtraCost(extra) >
                                                      0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ml-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "(" +
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "displayExtraPrice"
                                                                    )(
                                                                      extra,
                                                                      _vm.currentVol
                                                                    )
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("div", {
                                      staticClass: "spacer-25",
                                      attrs: { id: "bottomAdd" },
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "d-inline-block" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-layout",
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    !_vm.$store.getters
                                                      .hidePrices
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "biggerFont",
                                                          },
                                                          [
                                                            _vm._v("Preis: "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "preis titleFont",
                                                                class: {
                                                                  oprice:
                                                                    _vm.item
                                                                      .streichPreis,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "priceTotal"
                                                                    )(_vm.total)
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm.item
                                                              .streichPreis
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "streichPreisCrossed ml-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "price"
                                                                        )(
                                                                          _vm
                                                                            .item
                                                                            .streichPreis
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.item.kilopreis &&
                                                    !_vm.$store.getters
                                                      .hidePrices
                                                      ? _c("div", [
                                                          _c("b", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.item
                                                                  .kilopreis
                                                              )
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                    !_vm.$store.getters
                                                      .hidePrices
                                                      ? _c("div", [
                                                          _vm._v(
                                                            "inkl. MwSt. "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c("v-flex", {
                                                  attrs: { xs6: "" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "spacer-20" }),
                                        _vm.buyable && _vm.loaded
                                          ? _c(
                                              "div",
                                              { staticClass: "d-flex fade-in" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-shrink-0 align-self-center",
                                                  },
                                                  [
                                                    !_vm.item.unikat
                                                      ? _c("table", [
                                                          _c("tr", [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "counterStuff minus",
                                                                on: {
                                                                  "&click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clickMinus.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  class: {
                                                                    invertImg:
                                                                      !_vm.bgLight,
                                                                  },
                                                                  attrs: {
                                                                    src: require("../assets/icons/item-minus.png"),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "counter",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.multiplicator
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "counterStuff",
                                                                on: {
                                                                  "&click":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clickPlus.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("img", {
                                                                  class: {
                                                                    invertImg:
                                                                      !_vm.bgLight,
                                                                  },
                                                                  attrs: {
                                                                    src: require("../assets/icons/item-plus.png"),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm.item.sizes &&
                                                _vm.item.sizes.length > 0
                                                  ? _c("add-to-cart-button", {
                                                      staticClass: "ml-3",
                                                      attrs: {
                                                        noblink: _vm.noblink,
                                                        total: 0,
                                                      },
                                                      nativeOn: {
                                                        "&click": function (
                                                          $event
                                                        ) {
                                                          return _vm.addToCart.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm.$store.state.enableItemNote &&
                                    _vm.buyable &&
                                    _vm.loaded
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pt-4 itmExtras fade-in",
                                          },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "nolabel panelField",
                                              attrs: {
                                                placeholder: "Anmerkung",
                                                illed: "",
                                                "hide-details": "",
                                                clearable: "",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.item.notes,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "notes",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.notes",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c("div", { staticClass: "spacer-15" }),
                                    _c("div", { staticClass: "pt-5" }, [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "text-none btn-df accentBtn",
                                              nativeOn: {
                                                "&click": function ($event) {
                                                  return _vm.clickWeiter.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v("Weiter Einkaufen"),
                                              ]),
                                            ]
                                          ),
                                          _vm.showWeiter
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "ml-3 btn-df checkoutButtonAnimation text-none",
                                                  nativeOn: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      return _vm.goCart.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(" CHECKOUT "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        medium: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " mdi-chevron-right "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "spacer-40" }),
                    _vm.showLightbox
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "lightbox d-flex justify-center align-center maxh",
                            on: {
                              "&click": function ($event) {
                                _vm.showLightbox = false
                              },
                            },
                          },
                          [
                            _vm.hasMoreImages
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "inner",
                                    staticStyle: {
                                      height: "95%",
                                      "max-height": "1000px",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-carousel",
                                      {
                                        staticStyle: {
                                          background: "transparent",
                                        },
                                        attrs: {
                                          height: "100%",
                                          "hide-delimiter-background": "",
                                        },
                                        nativeOn: {
                                          "&click": function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                        model: {
                                          value: _vm.sliderKey,
                                          callback: function ($$v) {
                                            _vm.sliderKey = $$v
                                          },
                                          expression: "sliderKey",
                                        },
                                      },
                                      _vm._l(
                                        _vm.allImages,
                                        function (mi, index) {
                                          return _c(
                                            "v-carousel-item",
                                            { key: index + 1 },
                                            [
                                              _c(
                                                "v-sheet",
                                                {
                                                  attrs: { height: "100%" },
                                                  nativeOn: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      _vm.showLightbox = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "sliderImg",
                                                    style: {
                                                      "background-image":
                                                        "url(" + mi + ")",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "close pointer",
                                        on: {
                                          "&click": function ($event) {
                                            _vm.showLightbox = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "white",
                                              large: "",
                                            },
                                          },
                                          [_vm._v("mdi-close-thick")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "inner" },
                                  [
                                    _c("v-img", {
                                      staticStyle: {
                                        width: "auto",
                                        "max-width": "var(--layout-width)",
                                        "max-height": "90vh",
                                        height: "90vh",
                                      },
                                      attrs: {
                                        src: _vm.imgSource,
                                        contain: "",
                                        position: "center top",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "close pointer",
                                        on: {
                                          "&click": function ($event) {
                                            _vm.showLightbox = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "white",
                                              large: "",
                                            },
                                          },
                                          [_vm._v("mdi-close-thick")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "v-container",
                      [
                        _vm.itemClone
                          ? _c(
                              "div",
                              [
                                _c("ItemDetailsTabs", {
                                  staticClass: "tablet",
                                  attrs: { item: _vm.itemClone },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("MyLine", { staticClass: "mt-4 mb-4" }),
                        !_vm.isTicketCategory() ? _c("DrinkCards") : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { xs12: "", md4: "" },
                  },
                  [_c("Warenkorb")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("FixBasket"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }